import {
  UnorderedListOutlined,
  BuildOutlined,
  BookOutlined,
  PartitionOutlined,
} from '@ant-design/icons';

// Items de navegación de la pantalla de mantención. Fuente única para
// MantencionBottomNav (mobile) y MantencionTopTabs (desktop).
export const MANTENCION_TABS = [
  { k: 'checklist', label: 'Checklist', Icon: UnorderedListOutlined },
  { k: 'estados', label: 'Estados', Icon: BuildOutlined },
  { k: 'bitacora', label: 'Bitácora', Icon: BookOutlined },
  { k: 'componentes', label: 'Componentes', Icon: PartitionOutlined },
];
